export default {
  title: 'Отладка',

  titles: {
    sendings: 'Последнее отправление',
    textFields: 'g-text-field варианты',

    reset: {
      all: 'Полный сброс',
      storage: 'Сброс хранилищ',
      cache: 'Сброс кешей',
      serviceWorker: 'Восстановление service worker',
      report: 'Результат сброса'
    }
  },

  labels: {
    version: 'Версия платформы',
    newVersion: 'Доступная версия',
    date: 'Дата и время',
    dateUTC: 'Дата и время UTC',
    timeZone: 'Таймзона',
    utcOffset: 'Смещение UTC',
    locale: 'Локаль интерфейса',
    viewport: 'Размер окна',
    screen: 'Размер экрана',
    pixelRatio: 'Плотность пикселей',
    userAgent: 'User agent',
    standalone: 'Запуск как PWA',
    host: 'Хост',
    protocol: 'Протокол',
    apiURL: 'Адрес API',
    socketURL: 'Адрес WebSocket',
    route: 'Маршрут',
    routeName: 'Имя маршрута',
    online: 'Сеть',
    connection: 'Тип соединения',
    cookieEnabled: 'Cookies',
    indexedDB: 'IndexedDB',
    caches: 'Cache Storage',
    storageUsage: 'Занято в хранилище',
    storageQuota: 'Квота хранилища',
    localStorageSize: 'Размер localStorage',
    isLoggedAs: 'Вход под пользователем',

    ws: 'WebSocket',
    serviceWorker: 'Service worker',

    frontend: {
      title: 'Название платформы'
    },

    browser: {
      name: 'Название',
      version: 'Версия'
    },

    account: {
      username: 'Имя пользователя',
      balance: 'Баланс',
      id: 'ID',
      reseller: 'ID владельца',
      permissions: 'Количество прав',
      sendingTypes: 'Типы сообщений'
    },

    sending: {
      id: 'ID',
      recipient: 'Получатель',
      type: 'Тип отправления'
    },

    textFields: {
      outline: 'Outline mode',
      outlineLabel: 'Outline-label mode',
      lineLabel: 'Line-label mode'
    },

    reset: {
      socket: 'Соединение WebSocket',
      localStorage: 'localStorage',
      sessionStorage: 'sessionStorage',
      cookies: 'Cookies',
      serviceWorker: 'Service worker',
      cacheStorage: 'Cache Storage',
      indexedDB: 'IndexedDB'
    }
  },

  contents: {
    reset: {
      all: 'Будут удалены токен, настройки, избранное, cookies, кеши и базы данных браузера.<br>Снимок localStorage выгружается в файл до очистки.<br><strong class="mt-2">Вы уверены, что хотите продолжить?</strong>',
      storage: 'Будут удалены токен, настройки, избранное и cookies.<br>Снимок localStorage выгружается в файл до очистки.<br><strong class="mt-2">Вы уверены, что хотите продолжить?</strong>',
      cache: 'Будут удалены кеши и базы данных браузера.<br>Токен и настройки сохраняются.<br><strong class="mt-2">Вы уверены, что хотите продолжить?</strong>',
      serviceWorker: 'Будут сняты регистрации service worker и удалены кеши браузера.<br>Токен, настройки и базы данных сохраняются.<br>Страница будет загружена заново.<br><strong class="mt-2">Вы уверены, что хотите продолжить?</strong>'
    }
  },

  info: {
    download: {
      storage: '<strong>Копия сохранённых данных</strong><br>Сохраняет в файл содержимое локального хранилища - данные, которые платформа держит на этом компьютере. Ничего не удаляется и не изменяется.<br>Передайте файл в службу поддержки, если там просят подробности о состоянии платформы.'
    },

    reset: {
      serviceWorker: '<strong>Восстановление фонового обработчика</strong><br>Снимает регистрацию фонового обработчика страницы и удаляет сохранённые копии файлов платформы. Вход, настройки и базы данных остаются на месте, страница загружается заново и обработчик регистрируется снова.<br>Подходит, когда платформа открывается в устаревшем виде или обновления не появляются после перезагрузки страницы.',
      cache: '<strong>Сброс сохранённых копий</strong><br>Удаляет сохранённые копии файлов платформы и её базы данных. Вход и настройки остаются, входить заново не потребуется. Страница сама не перезагружается, обновите её после сброса.<br>Подходит, когда разделы показывают устаревшие данные или не открываются.',
      storage: '<strong>Сброс хранилищ</strong><br>Удаляет вход в учётную запись, настройки, избранное и служебные файлы сайта, язык интерфейса сохраняется. Сохранённые копии файлов и базы данных остаются. Копия локального хранилища выгружается в файл до очистки, после сброса потребуется войти заново.<br>Подходит, когда платформа работает не так, как ожидается, после смены учётной записи или настроек.',
      all: '<strong>Полный сброс</strong><br>Удаляет всё, что платформа хранит на этом компьютере: вход в учётную запись, настройки, избранное, служебные файлы сайта, сохранённые копии файлов и базы данных, язык интерфейса сохраняется. Копия локального хранилища выгружается в файл до очистки, после сброса потребуется войти заново.<br>Крайняя мера, когда остальные способы не помогли.'
    }
  },

  reset: {
    done: 'Выполнено',
    skipped: 'Пропущено',
    failed: 'Ошибка'
  },

  ws: {
    connected: 'Подключено',
    disconnected: 'Отключено'
  },

  serviceWorker: {
    unsupported: 'Не поддерживается браузером',
    unregistered: 'Не зарегистрирован',
    installing: 'Обновление устанавливается',
    waiting: 'Обновление скачано и ждёт применения'
  },

  values: {
    yes: 'Да',
    no: 'Нет',
    unavailable: 'Недоступно'
  },

  buttons: {
    reset: {
      all: 'Сброс',
      storage: 'Сброс',
      cache: 'Сброс',
      serviceWorker: 'Восстановить'
    },

    download: {
      storage: 'Скачать'
    },

    clean: {
      storage: 'Очистить хранилище'
    }
  }
}
